/**
 * Faithful port of source.service.ts from paranthaman-5.0
 * All functions maintain IDENTICAL output to the Ionic app
 */

// ─── Vaasaram (Sankalpam day name) ───
export function getVaasaram(englishDay) {
  const map = {
    Monday: 'இந்து', Tuesday: 'பௌம', Wednesday: 'ஸௌம்ய',
    Thursday: 'குரு', Friday: 'ப்ருகு', Saturday: 'ஸ்திர', Sunday: 'பானு'
  };
  return map[englishDay] || 'பானு';
}

// ─── Paksham ───
export function getPaksham(tamil, english) {
  if (tamil && tamil.length !== 0) return tamil;
  if (english === 'krishna' || english === 'Krishna') return 'க்ருஷ்ண';
  return 'சுக்ல';
}

// ─── Rahu Kalam ───
export function getRahuKala(engDay) {
  const map = {
    Monday: '7.30 to 9.00 am', Tuesday: '3.00 to 4.30 pm',
    Wednesday: '12.00 to 1.30 pm', Thursday: '1.30 to 3.00 pm',
    Friday: '10.30 to 12.00 noon', Saturday: '9.00 to 10.30 am',
    Sunday: '4.30 to 6.00 pm'
  };
  return map[engDay] || '';
}

// ─── Yama Kandam ───
export function getYamaKanda(engDay) {
  const map = {
    Monday: '10.30 to 12.00 noon', Tuesday: '9.00 to 10.30 am',
    Wednesday: '7.30 to 9.00 am', Thursday: '6.00 to 7.30 am',
    Friday: '3.00 to 4.30 pm', Saturday: '1.30 to 3.00 pm',
    Sunday: '12.00 to 1.30 pm'
  };
  return map[engDay] || '';
}

// ─── Kuligai Kalam ───
export function getKuliga(engDay) {
  const map = {
    Monday: '1.30 to 3.00 pm', Tuesday: '12.00 to 1.30 pm',
    Wednesday: '10.30 to 12.00 noon', Thursday: '9.00 to 10.30 am',
    Friday: '7.30 to 9.00 am', Saturday: '6.00 to 7.30 am',
    Sunday: '3.00 to 4.30 pm'
  };
  return map[engDay] || '';
}

// ─── Soolam ───
export function getSoola(engDay) {
  const map = {
    Monday: 'கிழக்கு-9.12am-பரிகாரம்-தயிர்',
    Tuesday: 'வடக்கு-10.48am-பரிகாரம்-பால்',
    Wednesday: 'வடக்கு-12.24am-பரிகாரம்-பால்',
    Thursday: 'தெற்கு-2.00pm-பரிகாரம்-வெல்லம்',
    Friday: 'மேற்கு-10.48am-பரிகாரம்-வெல்லம்',
    Saturday: 'கிழக்கு--9.12am-பரிகாரம்-தயிர்',
    Sunday: 'மேற்கு - 10.48am பரிகாரம்-வெல்லம்'
  };
  return map[engDay] || '';
}

// ─── Nalla Neram ───
export function getGoodTime(engDay) {
  const map = {
    Monday: '6 to 7 am, 12 to 2 pm, 6 to 8pm',
    Tuesday: '10.30 to 11am, 12 to 1 pm, 7 to 10pm',
    Wednesday: '9 to 10am, 1.30 to 3 pm, 7 to 10pm',
    Thursday: '9 to 10.30am, 1 to 1.30pm, 6 to 7pm',
    Friday: '6 to 9am, 1 to 1.30pm, 5 to 6pm',
    Saturday: '10.30 to 12n, 12 to 1pm, 5 to 7.30pm',
    Sunday: '7.30 to 10am, 2 to 4.30pm'
  };
  return map[engDay] || '';
}

// ─── Sunrise (minutes from 6am) ───
export function getSunrise(suriyan) {
  let Sunrise = parseFloat(suriyan);
  Sunrise = ConvertToMinutes(Sunrise) - (6.00 * 60);
  Sunrise = parseFloat(Sunrise.toFixed(2));
  return Sunrise > 0 ? '+' + Sunrise.toString() : Sunrise;
}

export function ConvertToMinutes(InputValue) {
  let mins = parseInt(InputValue) * 60.00;
  mins = mins + Math.round(parseFloat((InputValue - parseInt(InputValue)).toFixed(2)) * 100);
  return mins;
}

// ─── Time Arithmetic (used for lagnam calculations) ───
export function addTwoTimes(time1, time2) {
  let mani1 = parseInt(time1);
  let time3 = (time1 % 1).toFixed(2);
  let time4 = mani1 * 60;
  let time5 = time4 + (parseFloat(time3) * 100);
  let time2A = parseInt(time2);
  let time2B = (time2 % 1).toFixed(2);
  let time2C = time2A * 60;
  let time2D = (parseFloat(time2B) * 100);
  let time2E = time2C + time2D;
  let totalMinutes = time2E + time5;
  let mani3 = Math.trunc(totalMinutes / 60);
  let mani4 = totalMinutes - (mani3 * 60);
  let mani5 = mani4 / 100;
  return mani3 + mani5;
}

export function diffTwoTimes(time1, time2) {
  return addTwoTimes(time1, -time2);
}

export function maniToNazhi(A, B) {
  let time2 = addTwoTimes(A, -B);
  let nazhi1 = parseInt(time2) * 60;
  let nazhi2 = (time2 % 1).toFixed(2);
  let nazhi3 = Math.floor(+nazhi2 * 100);
  let nazhi4 = Math.trunc((nazhi1 + nazhi3) / 24);
  let nazhi5 = (nazhi1 + nazhi3) - (nazhi4 * 24);
  let nazhi6 = (nazhi5 * 2.5) / 100;
  return (nazhi4 + nazhi6).toFixed(2);
}

// ─── Chandrashtamam ───
export function getchandrashtamam(starnumber) {
  const map = {
    1:'உத்ரம்', 2:'ஹஸ்தம்', 3:'சித்திரை', 4:'ஸ்வாதி', 5:'விசாகம்',
    6:'அநுஷம்', 7:'கேட்டை', 8:'மூலம்', 9:'பூராடம்', 10:'உத்ராடம்',
    11:'திருவோணம்', 12:'அவிட்டம்', 13:'சதயம்', 14:'பூரட்டாதி', 15:'உத்ரட்டாதி',
    16:'ரேவதி', 17:'அஸ்விநி', 18:'பரணி', 19:'கார்த்திகை', 20:'ரோகிணி',
    21:'மிருகசீர்ஷம்', 22:'திருவாதிரை', 23:'புனர்பூசம்', 24:'பூசம்', 25:'ஆயில்யம்',
    26:'மகம்', 27:'பூரம்'
  };
  return map[starnumber] || '';
}

// ─── Porutham (compatible sets) ───
export function getPoruththam(starnumber) {
  const mod = ((starnumber - 1) % 9) + 1;
  const map = {
    1: '2, 3, 5, 7, 9', 2: '1, 3, 4, 6, 8', 3: '2, 4, 5, 7, 9',
    4: '1, 3, 5, 6, 8', 5: '2, 4, 6, 7, 9', 6: '1, 3, 5, 7, 8',
    7: '2, 4, 6, 8, 9', 8: '1, 3, 5, 7, 9', 9: '1, 2, 4, 6, 8'
  };
  return map[mod] || 'Some error';
}

// ─── Amudha/Siddha/Marana Yogam ───
export function getYogam(Yog) {
  if (!Yog) return '';
  let Yoga = Yog.substring(0, 2);
  if (Yoga === 'ம-') return 'மரண';
  if (Yoga === 'அ' || Yoga === 'அ-') return 'அமிர்த';
  if (Yoga === 'சி' || Yoga === 'சி-') return 'சித்த';
  return '';
}

export function getYogam2(Yog) {
  if (!Yog) return '';
  let Yoga2 = Yog.substring(2, 5);
  if (Yoga2 === 'ம' || Yoga2 === '-ம') return 'மரண';
  if (Yoga2 === 'அ' || Yoga2 === '-அ') return 'அமிர்த';
  if (Yoga2 === 'சி' || Yoga2 === '-சி') return 'சித்த';
  return '';
}

// ─── Thithyam (Sankalpam thithi name) ───
export function getThithyam(thithinum) {
  const n = Number(thithinum);
  const map = {
    0:'அமாவாஸ்யாயாம்', 30:'அமாவாஸ்யாயாம்', 15:'பௌர்ணமாஸ்யாம்',
    1:'ப்ரதமாயாம்', 16:'ப்ரதமாயாம்', 2:'த்விதீயாயாம்', 17:'த்விதீயாயாம்',
    3:'த்ருதீயாயாம்', 18:'த்ருதீயாயாம்', 4:'சதுர்த்தியாம்', 19:'சதுர்த்தியாம்',
    5:'பஞ்சம்யாம்', 20:'பஞ்சம்யாம்', 6:'ஷஷ்ட்யாம்', 21:'ஷஷ்ட்யாம்',
    7:'ஸப்தம்யாம்', 22:'ஸப்தம்யாம்', 8:'அஷ்டம்யாம்', 23:'அஷ்டம்யாம்',
    9:'நவம்யாம்', 24:'நவம்யாம்', 10:'தசம்யாம்', 25:'தசம்யாம்',
    11:'ஏகாதஸ்யாம்', 26:'ஏகாதஸ்யாம்', 12:'த்வாதஸ்யாம்', 27:'த்வாதஸ்யாம்',
    13:'த்ரையோதஸ்யாம்', 28:'த்ரையோதஸ்யாம்', 14:'சதுர்தஸ்யாம்', 29:'சதுர்தஸ்யாம்'
  };
  return map[n] || 'சுபதிதி';
}

// ─── Nakshatra Yukthayaam (Sankalpam star name) ───
export function getNakshatraYukthayaam(sankalpaStar) {
  const map = {
    1:'அஸ்விநீ', 2:'அபபரணீ', 3:'க்ருத்திகா', 4:'ரோஹிணீ', 5:'ம்ருகசிரோ',
    6:'ஆர்த்ரா', 7:'புனர்வசு', 8:'புஷ்ய', 9:'ஆச்லேஷா', 10:'மகா',
    11:'பூர்வபல்குனீ', 12:'உத்ரபல்குனீ', 13:'ஹஸ்த', 14:'சித்ரா', 15:'ஸ்வாதீ',
    16:'விசாகா', 17:'அநூராதா', 18:'ஜ்யேஷ்டா', 19:'மூலா', 20:'பூர்வாஷாடா',
    21:'உத்ராஷாடா', 22:'ச்ரவண', 23:'ச்ரவிஷ்டா', 24:'சதபிஷக்', 25:'பூர்வப்ரோஷ்டபதா',
    26:'உத்ரப்ரோஷ்டபதா', 27:'ரேவதீ'
  };
  return map[sankalpaStar] || 'அஸ்விநீ';
}

// ─── Ayanam ───
export function getAyane(tamilMonthNum) {
  if (tamilMonthNum >= 1 && tamilMonthNum <= 3) return 'உத்தராயணே';
  if (tamilMonthNum >= 4 && tamilMonthNum <= 9) return 'தக்ஷிணாயனே';
  if (tamilMonthNum >= 10 && tamilMonthNum <= 12) return 'உத்தராயணே';
  return 'தக்ஷிணாயனே';
}

// ─── Ruthu ───
export function getRuthu(MonthNo) {
  const map = {
    1:'வஸந்த', 2:'வஸந்த', 3:'க்ரீஷ்ம', 4:'க்ரீஷ்ம',
    5:'வருஷ', 6:'வருஷ', 7:'ஸரத்', 8:'ஸரத்',
    9:'ஹேமந்த', 10:'ஹேமந்த', 11:'சிசிர', 12:'சிசிர'
  };
  return map[MonthNo] || 'வஸந்த';
}

// ─── Mase (Sankalpam month name) ───
export function getMaseTamil(tamilMonthNum) {
  const map = {
    1:'மேஷ', 2:'ரிஷப', 3:'மிதுன', 4:'கடக',
    5:'ஸிம்ஹ', 6:'கன்யா', 7:'துலா', 8:'வ்ருச்சிக',
    9:'ச்சாப', 10:'மகர', 11:'கும்ப', 12:'மீன'
  };
  return map[tamilMonthNum] || 'மேஷ';
}

// ─── Panchagam (remainder-based) ───
export function panchagam(rem) {
  const map = {
    0:'நிஷ்பஞ்சகம்', 3:'நிஷ்பஞ்சகம்', 5:'நிஷ்பஞ்சகம்', 7:'நிஷ்பஞ்சகம்', 9:'நிஷ்பஞ்சகம்',
    1:'ம்ருத்யு பஞ்சகம்', 2:'அக்னி பஞ்சகம்', 4:'ராஜ பஞ்சகம்',
    6:'சோர பஞ்சகம்', 8:'ரோக பஞ்சகம்'
  };
  return map[rem] || 'Something wrong';
}

// ─── Pariharam (remedy for panchagam) ───
export function pariharam(rem) {
  const map = {
    0:'பரிகாரம் தேவையில்லை', 3:'பரிகாரம் தேவையில்லை',
    5:'பரிகாரம் தேவையில்லை', 7:'பரிகாரம் தேவையில்லை',
    9:'பரிகாரம் தேவையில்லை',
    1:'ரத்தின தானம்', 2:'சந்தன தானம்', 4:'எலுமிச்சை தானம்',
    6:'தீப தானம்', 8:'தான்ய தானம்'
  };
  return map[rem] || '';
}

// ─── Lagnam Data ───
export const LagnaData = [
  { Lno:1, LName:'மேஷ', LDuration:1.49, LDurvam:5, LState:'சர லக்னம்' },
  { Lno:2, LName:'ரிஷப', LDuration:2.02, LDurvam:7, LState:'ஸ்திர லக்னம்' },
  { Lno:3, LName:'மிதுன', LDuration:2.11, LDurvam:0, LState:'உபய லக்னம்' },
  { Lno:4, LName:'கடக', LDuration:2.08, LDurvam:0, LState:'சர லக்னம்' },
  { Lno:5, LName:'சிம்ம', LDuration:2.01, LDurvam:0, LState:'ஸ்திர லக்னம்' },
  { Lno:6, LName:'கன்னி', LDuration:1.59, LDurvam:0, LState:'உபய லக்னம்' },
  { Lno:7, LName:'துலா', LDuration:2.04, LDurvam:0, LState:'சர லக்னம்' },
  { Lno:8, LName:'வ்ருச்சிக', LDuration:2.10, LDurvam:0, LState:'ஸ்திர லக்னம்' },
  { Lno:9, LName:'தனுசு', LDuration:2.08, LDurvam:0, LState:'உபய லக்னம்' },
  { Lno:10, LName:'மகர', LDuration:1.55, LDurvam:2, LState:'சர லக்னம்' },
  { Lno:11, LName:'கும்ப', LDuration:1.43, LDurvam:4, LState:'ஸ்திர லக்னம்' },
  { Lno:12, LName:'மீன', LDuration:1.49, LDurvam:6, LState:'உபய லக்னம்' },
];

// ─── Lagnam Thyajyam ───
export function getLagnamThyajyam(mn) {
  if ([1,2,6,9].includes(mn)) return 'First 18 min Thyajyam';
  if ([3,5,7,11].includes(mn)) return 'Mid 18 min Thyajyam';
  if ([4,8,10,12].includes(mn)) return 'Last 18 min Thyajyam';
  return '';
}

// ─── Backend API URL ───
export const PANCHANGAM_API = 'https://brahminsnet.com:8082/v1/getPanchangamDetails';
export const ALLOWED_DATES_API = 'https://brahminsnet.com:8082/v1/getAllowedDates';


export const mystar = [
    {value: '0', name: "தெரியாது"},
    {value: '1', name: "அஸ்வினி"},
    {value: '2', name: "பரணி"},
    {value: '3', name: "கார்த்திகை"},
    {value: '4', name: "ரோகிணி"},
    {value: '5', name: "ம்ருகசீர்ஷம்"},
    {value: '6', name: "திருவாதிரை"},
    {value: '7', name: "புனர்பூசம்"},
    {value: '8', name: "பூசம்"},
    {value: '9', name: "ஆயில்யம்"},
    {value: '10', name: "மகம்"},
    {value: '11', name: "பூரம்"},
    {value: '12', name: "உத்ரம்"},
    {value: '13', name: "ஹஸ்தம்"},
    {value: '14', name: "சித்திரை"},
    {value: '15', name: "ஸ்வாதி"},
    {value: '16', name: "விசாகம்"},
    {value: '17', name: "அநுஷம்"},
    {value: '18', name: "கேட்டை"},
    {value: '19', name: "மூலம்"},
    {value: '20', name: "பூராடம்"},
    {value: '21', name: "உத்ராடம்"},
    {value: '22', name: "திருவோணம்"},
    {value: '23', name: "அவிட்டம்"},
    {value: '24', name: "சதயம்"},
    {value: '25', name: "பூரட்டாதி"},
    {value: '26', name: "உத்ரட்டாதி"},
    {value: '27', name: "ரேவதி"},
  ];
export const abhivadhi = [
    {
      "Sno": 37,
      "Gothram": "Aabasthamba",
      "Pravaram": "Aangirasa, Bharhaspathya, Bharatwaja - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 79,
      "Gothram": "Aachvalaayana",
      "Pravaram": "Vaasishta, Aindrapramatha, Aabarathvasasya - Thrayarsheya"
    },
    {
      "Sno": 66,
      "Gothram": "AagamarshaNa",
      "Pravaram": "Vaiswamithra, AagamarshaNa, Kausika - Thrayarsheya"
    },
    {
      "Sno": 102,
      "Gothram": "Aagasthi",
      "Pravaram": "Agasthya, Maahendra, Maayobhuva - Thryarisheya, pravaranvitha"
    },
    {
      "Sno": 14,
      "Gothram": "AartishENa",
      "Pravaram": "Bhargava, AarttisheNa, AnUpa - Thrayarsheya pravaranvitha:"
    },
    {
      "Sno": 15,
      "Gothram": "Aaswalaayana",
      "Pravaram": "Bhargava, Vaadhyaksha, Daivadaasa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 48,
      "Gothram": "Aathreya",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 60,
      "Gothram": "Aathreya",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 38,
      "Gothram": "Aayaasya",
      "Pravaram": "Aangirassa, Aayaasya, Gauthama - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 103,
      "Gothram": "Agasthi",
      "Pravaram": "Agasthya, Dhradyavrutha, Aidhmavaaha - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 100,
      "Gothram": "Agasthya",
      "Pravaram": "Agasthya - Ekarisheya, pravaranvitha:"
    },
    {
      "Sno": 99,
      "Gothram": "Asitha",
      "Pravaram": "Kaasyapa, Aavathsaara, Aasitha - Thrayarsheya"
    },
    {
      "Sno": 50,
      "Gothram": "Athri",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 13,
      "Gothram": "Avada",
      "Pravaram": "Bhargava, Aurva, Jamadagnya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 97,
      "Gothram": "Baukakshi",
      "Pravaram": "Kaasyapa, Aavathsaara, Aasitha - Thrayarsheya"
    },
    {
      "Sno": 57,
      "Gothram": "Bhaaleya",
      "Pravaram": "Aathreya, Vaamarathya, Bauthrika - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 29,
      "Gothram": "Bharatwaja",
      "Pravaram": "Aangirasa, Bhaarhaspathya, Bharatwaja - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 5,
      "Gothram": "Bhaulathsya",
      "Pravaram": "Bhargava, Aurva, jamadagnya -  Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 59,
      "Gothram": "Bheejaavaaba",
      "Pravaram": "Aathreya, Aarsanaanasa, Aadhitha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 83,
      "Gothram": "Bhodayana",
      "Pravaram": "Vaasishta, Aathreya, JaadhookarNya - Thrayarsheya"
    },
    {
      "Sno": 94,
      "Gothram": "Bruku",
      "Pravaram": "Kaasyapa, Aavathsaara, Naithrava - Thrayarsheya"
    },
    {
      "Sno": 54,
      "Gothram": "Dattathreya",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 73,
      "Gothram": "Devaraatha",
      "Pravaram": "Vaiswamithra, Devaraatha, Aulitha - Thrayarshey"
    },
    {
      "Sno": 56,
      "Gothram": "Dhaksha ( Dakshi)",
      "Pravaram": "Aathreya, Kaavishtira, Bhaurvathitha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 55,
      "Gothram": "Dhananjaya",
      "Pravaram": "Aathreya, Aarsanaanasa, Kaavishtira - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 23,
      "Gothram": "GaargEya",
      "Pravaram": "Aangirasa, Gaargya, Chaithya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 24,
      "Gothram": "GaargEya",
      "Pravaram": "Aangirasa, Bhaarhaspathya, Bharatheevaja, Sainya, Gargya -    Pancharsheya pravaranvitha:"
    },
    {
      "Sno": 42,
      "Gothram": "Garga",
      "Pravaram": "Aangirasa, Chainya, Gargaya (Garka) - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 10,
      "Gothram": "Garthsamatha",
      "Pravaram": "Bhargava, Garthsamatha - Dvayarisheya, pravaranvitha:"
    },
    {
      "Sno": 67,
      "Gothram": "Gatha",
      "Pravaram": "Vaiswamithra, Maaduchandasa, Aaja - Thrayarsheya"
    },
    {
      "Sno": 53,
      "Gothram": "Gauriveetha",
      "Pravaram": "Aathreya, Aarsanaanasa, Baurvaathitha - thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 25,
      "Gothram": "Gauthama",
      "Pravaram": "Aangirasa, Aayarsaya, Gauthama - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 36,
      "Gothram": "Haritha",
      "Pravaram": "Aangirasa, Ambarisha, Yauvanaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 78,
      "Gothram": "Haritha",
      "Pravaram": "Vaasishta - Ekarsheya"
    },
    {
      "Sno": 101,
      "Gothram": "Idhmavaaha",
      "Pravaram": "Agasthya - Ekarisheya, Pravaranvitha:"
    },
    {
      "Sno": 104,
      "Gothram": "Idhmavaaha",
      "Pravaram": "Agasthya, Vaathyasva, Aidhmavaaha - thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 2,
      "Gothram": "Jaabaali",
      "Pravaram": "Bhargava, Vaithahavya, Raivasa -  Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 82,
      "Gothram": "JaadhookarNya",
      "Pravaram": "Vaasishta, Aindrapramatha, Aabarathvasasya - Thrayarsheya"
    },
    {
      "Sno": 3,
      "Gothram": "Jaamadagnya",
      "Pravaram": "Bhargava, Aurva, jamadagnya -  Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 72,
      "Gothram": "Jabhala (Jabali)",
      "Pravaram": "Vaiswamithra, Devaraatha, Audhala - Thrayarsheya"
    },
    {
      "Sno": 4,
      "Gothram": "Jaimini",
      "Pravaram": "Bhargava, Vaithahavya, Raivasa -  Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 1,
      "Gothram": "Jamadagni",
      "Pravaram": "Bhargava, Syavana, Aabnavaana - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 70,
      "Gothram": "Kaalava",
      "Pravaram": "Vaiswamithra, Devaraatha, Audhala - Thrayarsheya"
    },
    {
      "Sno": 81,
      "Gothram": "KaaNva",
      "Pravaram": "Vaasishta, Aindrapramatha, Aabarathvasasya - Thrayarsheya"
    },
    {
      "Sno": 18,
      "Gothram": "Kaargya",
      "Pravaram": "Bhargava, Vaithahavya, Revasa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 92,
      "Gothram": "Kaasyapa",
      "Pravaram": "Kaasyapa, Aasitha, Daivala - Thrayarsheya"
    },
    {
      "Sno": 17,
      "Gothram": "Kaathyaayana",
      "Pravaram": "Bhargava, AartishENa, AnUpa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 68,
      "Gothram": "Kaathyaayana",
      "Pravaram": "Vaiswamithra, Kathya, Adgeetha - Thrayarsheya"
    },
    {
      "Sno": 41,
      "Gothram": "Kabila",
      "Pravaram": "Aangirasa, Aamaheeyava, Aurukshyasa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 93,
      "Gothram": "Kachyapa",
      "Pravaram": "Kaasyapa, Aavathsaara, Naithruva, Reba, Raiba, Sandila, Chandilya - Sapthaarsheya"
    },
    {
      "Sno": 65,
      "Gothram": "Kadhaka",
      "Pravaram": "Vaiswamithra, Kadhaka - Dhwayarsheya"
    },
    {
      "Sno": 69,
      "Gothram": "Kamakaayana",
      "Pravaram": "Vaiswamithra, Devaseevarasa, DaivaTharasa (Rethasa) - Thrayarsheya"
    },
    {
      "Sno": 22,
      "Gothram": "Kamyaangirasa",
      "Pravaram": "Aangirasa, Aamahaavya, Aurushaaya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 11,
      "Gothram": "Kanaka",
      "Pravaram": "Bhargava, Garthsamatha - Dvayarisheya, pravaranvitha:"
    },
    {
      "Sno": 39,
      "Gothram": "KaNva",
      "Pravaram": "Aangirasa, Ajameeta, KaaNva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 40,
      "Gothram": "KaNva",
      "Pravaram": "Aangirasa, Aamaheeyava, Aurukshyasa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 16,
      "Gothram": "Kasyapi",
      "Pravaram": "Bhargava, Vaidahvya, Saavethasa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 45,
      "Gothram": "Kaundinya",
      "Pravaram": "Aangirasa, Bharhaspathya, Bharatwaja - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 74,
      "Gothram": "Kaundinya",
      "Pravaram": "Vaasishta, MaithravaruNa, Kaundinya - Thrayarsheya"
    },
    {
      "Sno": 71,
      "Gothram": "Kausika",
      "Pravaram": "Vaiswamithra, Salangayana, Kausika - Thrayarsheya"
    },
    {
      "Sno": 61,
      "Gothram": "Kausika (Kusika)",
      "Pravaram": "Vaiswamithra, AagamarshaNa, Kausika - Thrayarsheya"
    },
    {
      "Sno": 19,
      "Gothram": "Kruthsamatha",
      "Pravaram": "Bhargava, Saunahothra, Gaarthsamatha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 43,
      "Gothram": "Kuthsa",
      "Pravaram": "Aangirasa, Ambareesha, Yauvanaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 44,
      "Gothram": "Kuthsa",
      "Pravaram": "Aangirasa, Maandathra, Kauthsa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 47,
      "Gothram": "Lohitha",
      "Pravaram": "Aangirasa, Vaichvamitra, Lohitha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 62,
      "Gothram": "Lohitha",
      "Pravaram": "Vaiswamithra, Ashtaka, Lohitha - Thrayarsheya"
    },
    {
      "Sno": 6,
      "Gothram": "Maandookeya",
      "Pravaram": "Bhargava, Aurva, jamadagnya -  Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 95,
      "Gothram": "Maareesa",
      "Pravaram": "Kaasyapa, Aavathsaara, Naithrava - Thrayarsheya"
    },
    {
      "Sno": 106,
      "Gothram": "Maayobhuva",
      "Pravaram": "Agasthya, Maahendra, Maayobhuva - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 7,
      "Gothram": "Maunabhargava",
      "Pravaram": "Bhargava, Vaithahavya, Saavethasa - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 85,
      "Gothram": "Mauthgala",
      "Pravaram": "Vaasishta, MaithravaruNa, Kaundinya - Thrayarsheya"
    },
    {
      "Sno": 28,
      "Gothram": "Mauthgalya",
      "Pravaram": "Aangirasa, Ambarisha, Mauthgalya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 30,
      "Gothram": "Mauthgalya",
      "Pravaram": "Aangirasa, Bhargyasva, Mauthgalya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 49,
      "Gothram": "Mauthgalya",
      "Pravaram": "Aathreya, Aarsanaanasa, Baurvaathitha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 84,
      "Gothram": "MithraavaruNa",
      "Pravaram": "Vaasishta, MaithravaruNa, Kaundinya - Thrayarsheya"
    },
    {
      "Sno": 52,
      "Gothram": "Muthkala",
      "Pravaram": "Aathreya, Aarsanaanasa, Baurvaathitha - thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 20,
      "Gothram": "Nairruthi",
      "Pravaram": "Bhargava, AartishENa, AnUpa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 87,
      "Gothram": "Naithruva Kasyapa",
      "Pravaram": "Kaasyapa, Aavathsaara, Naithruva - Thrayarsheya"
    },
    {
      "Sno": 27,
      "Gothram": "PaatharaayaNa",
      "Pravaram": "Aangirasa, Paurukuthsa, Thraasathasya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 75,
      "Gothram": "Parasara",
      "Pravaram": "Vaasishta, saakthya, Paarasarya - Thrayarsheya"
    },
    {
      "Sno": 58,
      "Gothram": "Pathanjala",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 26,
      "Gothram": "Paurukuthsa",
      "Pravaram": "Aangirasa, Paurukuthsa, Thraasathasya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 46,
      "Gothram": "Paurukuthsa",
      "Pravaram": "Aangirasa, Paurukuthsa, Aasathasya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 105,
      "Gothram": "Pulaha",
      "Pravaram": "Agasthya, Maahendra, Maayobhuva - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 96,
      "Gothram": "Raibya (Reba)",
      "Pravaram": "Kaasyapa, Aavathsaara, Raibya - Thrayarsheya"
    },
    {
      "Sno": 31,
      "Gothram": "Ratheethara",
      "Pravaram": "Aangirasa, Vairoopa, Raatheethara - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 88,
      "Gothram": "Reba Kasyapa",
      "Pravaram": "Kaasyapa, Aavathsaara, Rebaa - Thrayarsheya"
    },
    {
      "Sno": 64,
      "Gothram": "Saalaavatha",
      "Pravaram": "Vaiswamithra, Devaraatha, Authala - Thrayarsheya"
    },
    {
      "Sno": 89,
      "Gothram": "Saandilya",
      "Pravaram": "Kaasyapa, Aavathsaara, Saandilya - Thrayarsheya"
    },
    {
      "Sno": 90,
      "Gothram": "Saandilya",
      "Pravaram": "Kasyapa, Daivala, Asitha - Thrayarsheya"
    },
    {
      "Sno": 91,
      "Gothram": "Saandilya",
      "Pravaram": "Kaasyapa, Aavathsaara, Naithruva, Reba, Raiba, Sandila, Chandilya - Sapthaarsheya"
    },
    {
      "Sno": 34,
      "Gothram": "Sankruthi",
      "Pravaram": "Saathya, Saankruthya, Gauriveetha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 35,
      "Gothram": "Sankruthi",
      "Pravaram": "Aangirasa, Saaskruthya, Gauriveetha - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 33,
      "Gothram": "ShatamarshNa",
      "Pravaram": "Aangirasa, Thraasathasya, Pauruguthsa - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 9,
      "Gothram": "Srivathsa",
      "Pravaram": "Bhargava, Syavana, Aapnavana, Aurva, Jamadagya - Pancharisheya, pravaranvitha:"
    },
    {
      "Sno": 80,
      "Gothram": "Upamanyu",
      "Pravaram": "Vaasishta, Aindrapramatha, Aabarathvasasya - Thrayarsheya"
    },
    {
      "Sno": 51,
      "Gothram": "Uthaalaka",
      "Pravaram": "Aathreya, Aarsanaanasa, syaavaachva - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 21,
      "Gothram": "Uthasatha (Uthathya)",
      "Pravaram": "Aangirasa, Audathya, Gauthama - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 86,
      "Gothram": "Vaasida",
      "Pravaram": "Vaasishta, Aindrapramatha, Aaabarathvasasya - Thrayarsheya"
    },
    {
      "Sno": 76,
      "Gothram": "Vaasishta",
      "Pravaram": "Vaasishta, MaithravaruNa, Kaundinya - Thrayarsheya"
    },
    {
      "Sno": 98,
      "Gothram": "Vaathsya",
      "Pravaram": "Kaasyapa, Aavathsaara, Raibya - Thrayarsheya"
    },
    {
      "Sno": 77,
      "Gothram": "Vasishta",
      "Pravaram": "Vaasishta - Ekarsheya"
    },
    {
      "Sno": 8,
      "Gothram": "Vathoola",
      "Pravaram": "Bhargava, Vaithahavya, Saavethasa - Thrayarisheya, pravaranvitha:"
    },
    {
      "Sno": 32,
      "Gothram": "Vishnuvruththa",
      "Pravaram": "Aangirasa, Pauruguthsa, Thraasathasya - Thrayarsheya, pravaranvitha:"
    },
    {
      "Sno": 63,
      "Gothram": "Viswamithra",
      "Pravaram": "Vaiswamithra, Devaraatha, Authala - Thrayarsheya"
    },
    {
      "Sno": 12,
      "Gothram": "Yagnjapathi",
      "Pravaram": "Bhargava, Garthsamatha - Dvayarisheya, pravaranvitha:"
    }
  ];


export const suitsets = [
      {setno: 0, stars: 'சரியில்லை'},
      {setno: 1, stars: 'அஸ்வினி, மகம், மூலம்'},
      {setno: 2, stars: 'பரணி, பூரம், பூராடம்'},
      {setno: 3, stars: 'கார்த்திகை, உத்ரம், உத்ராடம்'},
      {setno: 4, stars: 'ரோகிணி, ஹஸ்தம், திருவோணம்'},
      {setno: 5, stars: 'ம்ருகசீர்ஷம், சித்திரை, அவிட்டம்'},
      {setno: 6, stars: 'திருவாதிரை, ஸ்வாதி, சதயம்'},
      {setno: 7, stars: 'புன்பூசம், விசாகம், பூரட்டாதி'},
      {setno: 8, stars: 'பூசம், அநுஷம், உத்ரட்டாதி'},
      {setno: 9, stars: 'ஆயில்யம், கேட்டை, ரேவதி'},
   ];


export const getSuitableStars = (currentStar) => {
    var starNumberToNameMapping = {
      1:"அஸ்விநி",
      2:"பரணி",
      3:"கார்த்திகை",
      4:"ரோஹிணி",
      5:"ம்ருகசீர்ஷம்",
      6:"திருவாதிரை",
      7:"புனர்பூசம்",
      8:"பூசம்",
      9:"ஆயில்யம்",
      10:"மகம்",
      11:"பூரம்",
      12:"உத்ரம்",
      13:"ஹஸ்தம்",
      14:"சித்திரை",
      15:"ஸ்வாதி",
      16:"விசாகம்",
      17:"அநுஷம்",
      18:"கேட்டை",
      19:"மூலம்",
      20:"பூராடம்",
      21:"உத்ராடம்",
      22:"திருவோணம்",
      23:"அவிட்டம்",
      24:"சதயம்",
      25:"பூரட்டாதி",
      26:"உத்ரட்டாதி",
      27:"ரேவதி"
    };
    var suitableSets = [2,4,6,8,9];
    var outputSet = [];
  let  chandraashtamamStar = this.getChandrashtamamStar(currentStar);
    for (var setId of suitableSets){
        var starSet1 = (currentStar - 1 + setId) % 27;
        starSet1 = starSet1 === 0 ? 27 : starSet1;
        if (starSet1 !== chandraashtamamStar){
            outputSet.push(starSet1);
        }
        var starSet2 = (currentStar - 1 + setId + 9) % 27;
        starSet2 = starSet2 === 0 ? 27 : starSet2;
        if (starSet2 !== chandraashtamamStar){
            outputSet.push(starSet2);
        }
               
        var starSet3 = (currentStar - 1 + setId + 18) % 27;
        starSet3 = starSet3 === 0 ? 27 : starSet3;
        if (starSet3 !== chandraashtamamStar){
            outputSet.push(starSet3);
        }
    }
    this.goodstars = outputSet;
       //this.suitable = outputSet.map(item => (starNumberToNameMapping[item]));
    // console.log(outputSet.map(item => (starNumberToNameMapping[item])));
  //  console.log('goog stars', mstr);
    return outputSet.map(item => (starNumberToNameMapping[item]));
    
  }
